const PRICE_ASSESSMENTS = {
  '/mineral-client/graphite': '/natural-graphite/natural-graphite-prices/chart',
  '/mineral-client/lithium': '/lithium/lithium-prices/chart',
  '/mineral-client/cobalt': '/cobalt/cobalt-prices/chart',
  '/price-assessments/cathodes': '/cathode',
  '/price-assessments/anodes': '/anode',
  '/price-assessments/price-dashboard': '/price-dashboard',
  '/price-assessments/price-dashboard/chart-builder':
    '/price-dashboard/chart-builder',
  '/price-assessments/price-dashboard/watchlist': '/price-dashboard/watchlist',
  '/price-assessments/lithium': '/lithium',
  '/price-assessments/lithium/reports':
    '/lithium/data-reports/price-assessments',
  '/price-assessments/lithium/chart': '/lithium/lithium-prices/chart',
  '/price-assessments/lithium/analysis':
    '/lithium/market-insights/price-assessment-analysis',
  '/price-assessments/lithium/price-customisation-tool':
    '/lithium/lithium-prices/price-customisation-tool',
  '/price-assessments/cobalt': '/cobalt',
  '/price-assessments/cobalt/reports': '/cobalt/data-reports/price-assessments',
  '/price-assessments/cobalt/chart': '/cobalt/cobalt-prices/chart',
  '/price-assessments/cobalt/analysis':
    '/cobalt/market-insights/price-assessment-analysis',
  '/price-assessments/cobalt/price-customisation-tool':
    '/cobalt/cobalt-prices/price-customisation-tool',
  '/price-assessments/nickel': '/nickel',
  '/price-assessments/nickel/reports': '/nickel/data-reports/price-assessments',
  '/price-assessments/nickel/chart': '/nickel/nickel-prices/chart',
  '/price-assessments/nickel/analysis':
    '/nickel/market-insights/price-assessment-analysis',
  '/price-assessments/nickel/price-customisation-tool':
    '/nickel/nickel-prices/price-customisation-tool',
  '/price-assessments/natural-graphite': '/natural-graphite',
  '/price-assessments/natural-graphite/reports':
    '/natural-graphite/data-reports/price-assessments',
  '/price-assessments/natural-graphite/chart':
    '/natural-graphite/natural-graphite-prices/chart',
  '/price-assessments/natural-graphite/analysis':
    '/natural-graphite/market-insights/price-assessment-analysis',
  '/price-assessments/natural-graphite/price-customisation-tool':
    '/natural-graphite/natural-graphite-prices/price-customisation-tool',
  '/price-assessments/synthetic-graphite': '/synthetic-graphite',
  '/price-assessments/synthetic-graphite/reports':
    '/synthetic-graphite/data-reports/price-assessments',
  '/price-assessments/synthetic-graphite/chart':
    '/synthetic-graphite/synthetic-graphite-prices/chart',
  '/price-assessments/anode': '/anode',
  '/price-assessments/anode/reports': '/anode/data-reports/price-assessments',
  '/price-assessments/anode/chart': '/anode/anode-prices/chart',
  '/price-assessments/anode/analysis':
    '/anode/market-insights/price-assessment-analysis',
  '/price-assessments/anode/capacities': '/anode/capacity-database',
  '/price-assessments/cathode': '/cathode',
  '/price-assessments/cathode/reports':
    '/cathode/data-reports/price-assessments',
  '/price-assessments/cathode/analysis':
    '/cathode/market-insights/price-assessment-analysis',
  '/price-assessments/cathode/capacities': '/cathode/capacity-database/cathode',
  '/price-assessments/lithium-ion-batteries': '/lithium-ion-batteries',
  '/price-assessments/lithium-ion-batteries/reports':
    '/lithium-ion-batteries/data-reports/price-assessments',
  '/price-assessments/lithium-ion-batteries/chart':
    '/lithium-ion-batteries/lithium-ion-batteries-prices/chart',
  '/price-assessments/lithium-ion-batteries/analysis':
    '/lithium-ion-batteries/market-insights/price-assessment-analysis',
  '/price-assessments/rare-earths': '/rare-earths',
  '/price-assessments/rare-earths/reports':
    '/rare-earths/data-reports/price-assessments',
  '/price-assessments/rare-earths/chart':
    '/rare-earths/rare-earths-prices/chart',
  '/price-assessments/rare-earths/analysis':
    '/rare-earths/market-insights/price-assessment-analysis',
  '/price-assessments/black-mass': '/recycling',
  '/price-assessments/black-mass/reports':
    '/recycling/data-reports/price-assessments',
  '/price-assessments/black-mass/chart': '/recycling/black-mass-prices/chart',
  '/recycling/recycling-prices': '/recycling/black-mass-prices',
  '/recycling/recycling-prices/chart': '/recycling/black-mass-prices/chart',
  '/recycling/recycling-prices/table': '/recycling/black-mass-prices',
  '/recycling/recycling-prices/index': '/recycling/black-mass-prices/index',
  '/price-assessments/black-mass/analysis':
    '/recycling/market-insights/price-assessment-analysis',
}

const MARKET_ASSESSMENTS = {
  '/market-assessments/sodium-ion-batteries': '/sodium-ion-batteries',
  '/market-assessments/sodium-ion-batteries/battery-cell-capacities':
    '/battery-gigafactory/capacity-database/sodium-ion-capacities',
  '/market-assessments/sodium-ion-batteries/anode': '/anode/capacity-database',
  '/market-assessments/sodium-ion-batteries/cathode':
    '/cathode/capacity-database',
  '/market-assessments/sodium-ion-batteries/reports':
    '/sodium-ion-batteries/data-reports/market-assessments',
  '/market-assessments/precursor-assessment':
    '/cathode/capacity-database/precursor',
  '/market-assessments/precursor-assessment/capacities':
    '/cathode/capacity-database/precursor',
  '/market-assessments/precursor-assessment/reports':
    '/cathode/data-reports/market-assessments',
  '/market-assessments/gigafactory-assessment':
    '/lithium-ion-batteries/capacity-database/gigafactory',
  '/market-assessments/gigafactory-assessment/capacities':
    '/lithium-ion-batteries/capacity-database/gigafactory',
  '/market-assessments/gigafactory-assessment/tier-ranking':
    '/lithium-ion-batteries/capacity-database/tier-ranking',
  '/market-assessments/gigafactory-assessment/reports':
    '/lithium-ion-batteries/data-reports/market-assessments',
  '/megafactories': '/lithium-ion-batteries/capacity-database/gigafactory',
  '/gigafactories': '/lithium-ion-batteries/capacity-database/gigafactory',
  '/market-assessments/gigafactories':
    '/lithium-ion-batteries/capacity-database/gigafactory',
  '/market-assessments/cathodes': '/cathode',
  '/market-assessments/anodes': '/anode',
}

const FORECASTS = {
  '/forecasts/lithium': '/lithium/data-reports/forecasts',
  '/forecasts/lithium/reports': '/lithium/data-reports/forecasts',
  '/forecasts/cobalt': '/cobalt/data-reports/forecasts',
  '/forecasts/cobalt/reports': '/cobalt/data-reports/forecasts',
  '/forecasts/nickel': '/nickel/data-reports/forecasts',
  '/forecasts/nickel/reports': '/nickel/data-reports/forecasts',
  '/forecasts/natural-graphite': '/natural-graphite/data-reports/forecasts',
  '/forecasts/natural-graphite/reports':
    '/natural-graphite/data-reports/forecasts',
  '/forecasts/synthetic-graphite': '/synthetic-graphite/data-reports/forecasts',
  '/forecasts/synthetic-graphite/reports':
    '/synthetic-graphite/data-reports/forecasts',
  '/forecasts/anode': '/anode/data-reports/forecasts',
  '/forecasts/anode/reports': '/anode/data-reports/forecasts',
  '/forecasts/cathode': '/cathode/data-reports/forecasts',
  '/forecasts/cathode/reports': '/cathode/data-reports/forecasts',
  '/forecasts/lithium-ion-batteries':
    '/battery-gigafactory/data-reports/forecasts',
  '/forecasts/lithium-ion-batteries/reports':
    '/battery-gigafactory/data-reports/forecasts',
  '/forecasts/rare-earths': '/rare-earths/data-reports/forecasts',
  '/forecasts/rare-earths/reports': '/rare-earths/data-reports/forecasts',
  '/forecasts/solid-state': '/solid-state/data-reports/forecasts',
  '/forecasts/solid-state/reports': '/solid-state/data-reports/forecasts',
  '/forecasts/recycling': '/recycling/data-reports/forecasts',
  '/forecasts/recycling/reports': '/recycling/data-reports/forecasts',
  '/forecasts/manganese': '/manganese/data-reports/forecasts',
  '/forecasts/manganese/reports': '/manganese/data-reports/forecasts',
  '/forecasts/silicon-anode': '/silicon-anode/data-reports/forecasts',
  '/forecasts/silicon-anode/reports': '/silicon-anode/data-reports/forecasts',
  '/forecasts/fluorspar': '/fluorspar/data-reports/forecasts',
  '/forecasts/fluorspar/reports': '/fluorspar/data-reports/forecasts',
  '/forecasts/phosphate': '/phosphate/data-reports/forecasts',
  '/forecasts/phosphate/reports': '/phosphate/data-reports/forecasts',
}

const ESG = {
  '/esg': '/sustainability',
  '/esg/lca': '/lca',
  '/esg/battery-emissions-analyser': '/battery-emissions-analyser',
  '/esg/lithium': '/lithium/data-reports/sustainability',
  '/esg/lithium/reports': '/lithium/data-reports/sustainability',
  '/esg/lithium/sustainability-index': '/lithium/sustainability',
  '/esg/cobalt': '/cobalt/data-reports/sustainability',
  '/esg/cobalt/reports': '/cobalt/data-reports/sustainability',
  '/esg/cobalt/sustainability-index': '/cobalt/sustainability',
  '/esg/nickel': '/nickel/data-reports/sustainability',
  '/esg/nickel/reports': '/nickel/data-reports/sustainability',
  '/esg/nickel/sustainability-index': '/nickel/sustainability',
  '/esg/graphite': '/natural-graphite/data-reports/sustainability',
  '/esg/graphite/reports': '/natural-graphite/data-reports/sustainability',
  '/esg/graphite/sustainability-index': '/natural-graphite/sustainability',
  '/esg/rare-earths': '/rare-earths/data-reports/sustainability',
  '/esg/rare-earths/reports': '/rare-earths/data-reports/sustainability',
  '/esg/rare-earths/sustainability-index': '/rare-earths/sustainability',
}

const NEWSLETTERS = {
  '/newsletter-signup': '/newsletters',
  '/price-spotlight-signup': '/newsletters',
  '/industry-reports': '/newsletters',
  '/policy-newsletter': '/newsletters',
  '/copper-weekly': '/newsletters',
}

export default {
  ...PRICE_ASSESSMENTS,
  ...MARKET_ASSESSMENTS,
  ...FORECASTS,
  ...ESG,
  ...NEWSLETTERS,
  '/request-for-proposal': '/consultancy',
  '/forecasts/graphite': '/natural-graphite/data-reports/forecasts',
  '/price-assessments/graphite/reports':
    '/natural-graphite/data-reports/price-assessments',
  '/market-assessments/sodium-ion-batteries/anode-capacities':
    '/anode/capacity-database',
  '/market-assessments/sodium-ion-batteries/cathode-capacities':
    '/sodium-ion-batteries/capacity-database/cathode',
  '/market-assessments/battery-cells':
    '/lithium-ion-batteries/data-reports/market-assessments/',
  '/tools/battery-emissions-analyser': '/battery-emissions-analyser',
  '/forecasts/battery-database':
    '/lithium-ion-batteries/data-reports/forecasts',
  '/webinar-sign-up': '/events/webinars',
  '/price-assessments/cathode/chart/': '/cathode/cathode-prices/chart',
  '/synthetic-graphite/analysis':
    '/synthetic-graphite/data-reports/price-assessments',
  '/price-assessments/raw-material-index': '/lithium/sustainability/overview/',
  '/membership/3d-printing-casts-new-dimension-on-metals':
    'https://source.benchmarkminerals.com/article/3d-printing-casts-new-dimension-on-metals',
  '/blog/membership/a-new-generation':
    'https://source.benchmarkminerals.com/article/a-new-generation',
  '/membership/a-new-generation':
    'https://source.benchmarkminerals.com/article/a-new-generation',
  '/blog/membership/a-pilgrims-progress':
    'https://source.benchmarkminerals.com/article/a-pilgrims-progress',
  '/membership/a-pilgrims-progress':
    'https://source.benchmarkminerals.com/article/a-pilgrims-progress',
  '/blog/membership/albemarle-shifts-focus-to-spodumene-but-fails-to-address-primary-lithium-supply':
    'https://source.benchmarkminerals.com/article/albemarle-shifts-focus-to-spodumene-but-fails-to-address-primary-lithium-supply',
  '/membership/albemarle-shifts-focus-to-spodumene-but-fails-to-address-primary-lithium-supply':
    'https://source.benchmarkminerals.com/article/albemarle-shifts-focus-to-spodumene-but-fails-to-address-primary-lithium-supply',
  '/blog/membership/are-battery-regulations-up-in-the-air':
    'https://source.benchmarkminerals.com/article/are-battery-regulations-up-in-the-air',
  '/membership/are-battery-regulations-up-in-the-air':
    'https://source.benchmarkminerals.com/article/are-battery-regulations-up-in-the-air',
  '/blog/membership/argentina-open-for-lithium-business-as-chiles-biggest-producer-invests':
    'https://source.benchmarkminerals.com/article/argentina-open-for-lithium-business-as-chiles-biggest-producer-invests',
  '/membership/argentina-open-for-lithium-business-as-chiles-biggest-producer-invests':
    'https://source.benchmarkminerals.com/article/argentina-open-for-lithium-business-as-chiles-biggest-producer-invests',
  '/blog/membership/batteries-can-spark-a-fourth-industrial-revolution-2':
    'https://source.benchmarkminerals.com/article/batteries-can-spark-a-fourth-industrial-revolution-2',
  '/membership/batteries-can-spark-a-fourth-industrial-revolution-2':
    'https://source.benchmarkminerals.com/article/batteries-can-spark-a-fourth-industrial-revolution-2',
  '/blog/membership/batteries-can-spark-a-fourth-industrial-revolution':
    'https://source.benchmarkminerals.com/article/batteries-can-spark-a-fourth-industrial-revolution',
  '/membership/batteries-can-spark-a-fourth-industrial-revolution':
    'https://source.benchmarkminerals.com/article/batteries-can-spark-a-fourth-industrial-revolution',
  '/blog/membership/battery-grade-graphite-set-for-record-year':
    'https://source.benchmarkminerals.com/article/battery-grade-graphite-set-for-record-year',
  '/membership/battery-grade-graphite-set-for-record-year':
    'https://source.benchmarkminerals.com/article/battery-grade-graphite-set-for-record-year',
  '/blog/membership/battery-grade-graphite-shortage-on-horizon-as-demand-rockets':
    'https://source.benchmarkminerals.com/article/battery-grade-graphite-shortage-on-horizon-as-demand-rockets',
  '/membership/battery-grade-graphite-shortage-on-horizon-as-demand-rockets':
    'https://source.benchmarkminerals.com/article/battery-grade-graphite-shortage-on-horizon-as-demand-rockets',
  '/blog/membership/billion-dollar-battery-bid-lays-marker-for-new-oil':
    'https://source.benchmarkminerals.com/article/billion-dollar-battery-bid-lays-marker-for-new-oil',
  '/membership/billion-dollar-battery-bid-lays-marker-for-new-oil':
    'https://source.benchmarkminerals.com/article/billion-dollar-battery-bid-lays-marker-for-new-oil',
  '/blog/membership/chiles-lithium-state-of-mind':
    'https://source.benchmarkminerals.com/article/chiles-lithium-state-of-mind',
  '/membership/chiles-lithium-state-of-mind':
    'https://source.benchmarkminerals.com/article/chiles-lithium-state-of-mind',
  '/blog/membership/china-loses-re-case-but-maintains-grip':
    'https://source.benchmarkminerals.com/article/china-loses-re-case-but-maintains-grip',
  '/membership/china-loses-re-case-but-maintains-grip':
    'https://source.benchmarkminerals.com/article/china-loses-re-case-but-maintains-grip',
  '/blog/membership/china-overtakes-japan-as-leading-separator-producer-amid-auto-surge':
    'https://source.benchmarkminerals.com/article/china-overtakes-japan-as-leading-separator-producer-amid-auto-surge',
  '/membership/china-overtakes-japan-as-leading-separator-producer-amid-auto-surge':
    'https://source.benchmarkminerals.com/article/china-overtakes-japan-as-leading-separator-producer-amid-auto-surge',
  '/blog/membership/cobalt-conflict-minerals-and-the-unjustified-stigmatisation-of-producers':
    'https://source.benchmarkminerals.com/article/cobalt-conflict-minerals-and-the-unjustified-stigmatisation-of-producers',
  '/membership/cobalt-conflict-minerals-and-the-unjustified-stigmatisation-of-producers':
    'https://source.benchmarkminerals.com/article/cobalt-conflict-minerals-and-the-unjustified-stigmatisation-of-producers',
  '/blog/membership/cobalts-hi-tech-blueprint':
    'https://source.benchmarkminerals.com/article/cobalts-hi-tech-blueprint',
  '/membership/cobalts-hi-tech-blueprint':
    'https://source.benchmarkminerals.com/article/cobalts-hi-tech-blueprint',
  '/blog/membership/copper-conflicted':
    'https://source.benchmarkminerals.com/article/copper-conflicted',
  '/membership/copper-conflicted':
    'https://source.benchmarkminerals.com/article/copper-conflicted',
  '/blog/membership/copper-slump-risks-a-crisis-for-cobalt':
    'https://source.benchmarkminerals.com/article/copper-slump-risks-a-crisis-for-cobalt',
  '/membership/copper-slump-risks-a-crisis-for-cobalt':
    'https://source.benchmarkminerals.com/article/copper-slump-risks-a-crisis-for-cobalt',
  '/blog/membership/critical-mineral-trends-for-2015':
    'https://source.benchmarkminerals.com/article/critical-mineral-trends-for-2015',
  '/membership/critical-mineral-trends-for-2015':
    'https://source.benchmarkminerals.com/article/critical-mineral-trends-for-2015',
  '/blog/membership/daimler-doubles-down-on-energy-storage-masterplan':
    'https://source.benchmarkminerals.com/article/daimler-doubles-down-on-energy-storage-masterplan',
  '/membership/daimler-doubles-down-on-energy-storage-masterplan':
    'https://source.benchmarkminerals.com/article/daimler-doubles-down-on-energy-storage-masterplan',
  '/blog/membership/disruptive-innovation-2':
    'https://source.benchmarkminerals.com/article/disruptive-innovation-2',
  '/membership/disruptive-innovation-2':
    'https://source.benchmarkminerals.com/article/disruptive-innovation-2',
  '/blog/membership/disruptive-innovation':
    'https://source.benchmarkminerals.com/article/disruptive-innovation',
  '/membership/disruptive-innovation':
    'https://source.benchmarkminerals.com/article/disruptive-innovation',
  '/blog/membership/enrc-suspends-worlds-largest-cobalt-metal-refinery':
    'https://source.benchmarkminerals.com/article/enrc-suspends-worlds-largest-cobalt-metal-refinery',
  '/membership/enrc-suspends-worlds-largest-cobalt-metal-refinery':
    'https://source.benchmarkminerals.com/article/enrc-suspends-worlds-largest-cobalt-metal-refinery',
  '/blog/membership/europe-moves-a-step-closer-to-conflict-minerals-crackdown':
    'https://source.benchmarkminerals.com/article/europe-moves-a-step-closer-to-conflict-minerals-crackdown',
  '/membership/europe-moves-a-step-closer-to-conflict-minerals-crackdown':
    'https://source.benchmarkminerals.com/article/europe-moves-a-step-closer-to-conflict-minerals-crackdown',
  '/blog/membership/europes-conflict-conundrum':
    'https://source.benchmarkminerals.com/article/europes-conflict-conundrum',
  '/membership/europes-conflict-conundrum':
    'https://source.benchmarkminerals.com/article/europes-conflict-conundrum',
  '/blog/membership/europes-conflict-conundrum-2':
    'https://source.benchmarkminerals.com/article/europes-conflict-conundrum-2',
  '/membership/europes-conflict-conundrum-2':
    'https://source.benchmarkminerals.com/article/europes-conflict-conundrum-2',
  '/blog/membership/evs-at-the-tipping-point-says-deutsche-bank':
    'https://source.benchmarkminerals.com/article/evs-at-the-tipping-point-says-deutsche-bank',
  '/membership/evs-at-the-tipping-point-says-deutsche-bank':
    'https://source.benchmarkminerals.com/article/evs-at-the-tipping-point-says-deutsche-bank',
  '/blog/membership/eye-of-the-storm-vw-electric-vehicles':
    'https://source.benchmarkminerals.com/article/eye-of-the-storm-vw-electric-vehicles',
  '/membership/eye-of-the-storm-vw-electric-vehicles':
    'https://source.benchmarkminerals.com/article/eye-of-the-storm-vw-electric-vehicles',
  '/blog/membership/faradays-future-begins-with-1bn-ev-plant-construction-in-nevada':
    'https://source.benchmarkminerals.com/article/faradays-future-begins-with-1bn-ev-plant-construction-in-nevada',
  '/membership/faradays-future-begins-with-1bn-ev-plant-construction-in-nevada':
    'https://source.benchmarkminerals.com/article/faradays-future-begins-with-1bn-ev-plant-construction-in-nevada',
  '/blog/membership/fears-of-lithium-supply-shortage-become-reality':
    'https://source.benchmarkminerals.com/article/fears-of-lithium-supply-shortage-become-reality',
  '/membership/fears-of-lithium-supply-shortage-become-reality':
    'https://source.benchmarkminerals.com/article/fears-of-lithium-supply-shortage-become-reality',
  '/blog/membership/formula-club-e-the-new-class':
    'https://source.benchmarkminerals.com/article/formula-club-e-the-new-class',
  '/membership/formula-club-e-the-new-class':
    'https://source.benchmarkminerals.com/article/formula-club-e-the-new-class',
  '/blog/membership/gates-it-is-too-expensive-to-store-energy':
    'https://source.benchmarkminerals.com/article/gates-it-is-too-expensive-to-store-energy',
  '/membership/gates-it-is-too-expensive-to-store-energy':
    'https://source.benchmarkminerals.com/article/gates-it-is-too-expensive-to-store-energy',
  '/blog/membership/geopolitics-of-mineral-supply':
    'https://source.benchmarkminerals.com/article/geopolitics-of-mineral-supply',
  '/membership/geopolitics-of-mineral-supply':
    'https://source.benchmarkminerals.com/article/geopolitics-of-mineral-supply',
  '/blog/membership/graftech-takeover-targets-new-energy-and-defence-markets':
    'https://source.benchmarkminerals.com/article/graftech-takeover-targets-new-energy-and-defence-markets',
  '/membership/graftech-takeover-targets-new-energy-and-defence-markets':
    'https://source.benchmarkminerals.com/article/graftech-takeover-targets-new-energy-and-defence-markets',
  '/blog/membership/graphites-first-price-index-launched':
    'https://source.benchmarkminerals.com/article/graphites-first-price-index-launched',
  '/membership/graphites-first-price-index-launched':
    'https://source.benchmarkminerals.com/article/graphites-first-price-index-launched',
  '/blog/membership/green-tech-evolution-of-high-purity-alumina':
    'https://source.benchmarkminerals.com/article/green-tech-evolution-of-high-purity-alumina',
  '/membership/green-tech-evolution-of-high-purity-alumina':
    'https://source.benchmarkminerals.com/article/green-tech-evolution-of-high-purity-alumina',
  '/blog/membership/has-critical-cobalt-been-overlooked':
    'https://source.benchmarkminerals.com/article/has-critical-cobalt-been-overlooked',
  '/membership/has-critical-cobalt-been-overlooked':
    'https://source.benchmarkminerals.com/article/has-critical-cobalt-been-overlooked',
  '/blog/membership/real-world-graphine':
    'https://source.benchmarkminerals.com/article/real-world-graphine',
  '/membership/real-world-graphine':
    'https://source.benchmarkminerals.com/article/real-world-graphine',
  '/membership': 'https://source.benchmarkminerals.com',
  '/media': 'https://source.benchmarkminerals.com/downloads/presentations',
  '/membership/benchmark-launches-lithium-ion-raw-material-price-index':
    'https://source.benchmarkminerals.com/article/benchmark-launches-lithium-ion-battery-raw-material-price-index',
  '/membership/benchmark-launches-lithium-ion-battery-raw-material-price-index':
    'https://source.benchmarkminerals.com/article/benchmark-launches-lithium-ion-battery-raw-material-price-index',
  '/unrepresentative-lme-lithium-prices-hamper-attempts-to-modernise-industry':
    '',
  '/membership/canada-puts-breaks-on-chinas-4-billion-lithium-acquisition-spree':
    'https://source.benchmarkminerals.com',
  '/megafactories/megafactory-tier-rankings':
    '/market-assessments/gigafactory-assessment/tier-ranking',
  '/anode-market-assessment': '/price-assessments/anode',
  '/cathode-market-assessment': '/price-assessments/cathode',
  '/mineral-client/cobalt-data-analysis': '/price-assessments/cobalt/reports',
  '/mineral-client/nickel-data-analysis': '/price-assessments/nickel/reports',
  '/mineral-client/lithium-data-analysis': '/price-assessments/lithium/reports',
  '/mineral-client/graphite-data-analysis':
    '/price-assessments/graphite/reports',
  '/membership-subscription':
    'https://source.benchmarkminerals.com/request-a-trial',
  '/consultancy/supply-chain-playbook-strategies': '/consultancy',
  '/archive': 'https://source.benchmarkminerals.com/downloads/presentations',
  '/magazine-archive':
    'https://source.benchmarkminerals.com/downloads/magazine',
  '/video-library': 'https://source.benchmarkminerals.com/video',
  '/webinars': '/events',
  '/events/benchmarksummit2021': '/events/battery-gigafactories-usa-2022',
  '/events/benchmarksummit2022': '/events/battery-gigafactories-usa-2022',
  '/events/battery-megafactories-europe-2021':
    '/events/battery-megafactories-europe-2022',
  '/events/battery-megafactories-europe-2021/location':
    '/events/battery-megafactories-europe-2022/location',
  '/events/battery-megafactories-europe-2021/register':
    '/events/battery-megafactories-europe-2022/register',
  '/worldtour2017': '/events/world-tour-2017',
  '/germany-2016': '/events',
  '/melboure-2015': '/events',
  '/sydney-2016': '/events',
  '/lithium-price-assessment-portal':
    '/lithium/market-insights/price-assessment-analysis',
  '/events/latin-american-lithium-white-gold-in-the-age-of-resource-nationalism':
    '/events/lithium-resource-nationalism-shifting-policies-in-chile-and-the-impact-on-lithium-in-south-america',
  '/events/battery-gigafactories-asia-pacific-2022':
    'https://events.benchmarkminerals.com/gigaapac2022',
  '/events/battery-gigafactories-asia-pacific-2022/register':
    'https://events.benchmarkminerals.com/bwLnA',
  '/events/benchmark-week-2021':
    'https://events.benchmarkminerals.com/d/rfqx5b',
  '/events/benchmark-week-2022':
    'https://events.benchmarkminerals.com/d/rfqx5b',
  '/events/battery-gigafactories-usa-2022/register':
    'https://events.benchmarkminerals.com/d/sfq4x4',
  '/events/battery-gigafactories-asia-pacific':
    'https://benchmarkevents.benchmarkminerals.com/gigaapac',
  '/events/world-tour-2023-toronto':
    'https://benchmarkevents.benchmarkminerals.com/worldtourtoronto',
  '/events/benchmark-week-2023':
    'https://benchmarkevents.benchmarkminerals.com/benchmarkweek23',
  '/events/world-tour': '/events/summits',
}
